var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"return-skeleton"},[_c('span',{staticClass:"skeleton-loader-shimmer return-skeleton__inner"}),_c('span',{staticClass:"skeleton-loader-shimmer return-skeleton__inner"}),_c('span',{staticClass:"skeleton-loader-shimmer return-skeleton__inner"})])
}]

export { render, staticRenderFns }